'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _mlComponent = require('ml-component');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = function (_ComponentBase) {
    _inherits(Component, _ComponentBase);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                location: this.props.location || this.context.location
            };
        }
    }, {
        key: 'transitionTo',
        value: function transitionTo(route) {
            var _this2 = this;

            var state = _extends({}, route.state, {
                inAppNav: true
            });

            if (state.redirect) {
                window.location = route.url;
            } else {
                //Avoid possiblity of dispatcher conflicts
                setTimeout(function () {
                    _this2.context.history.pushState(state, route.url, route.query);
                    if (!state.modal) {
                        //TODO: Is this necessary? Configurable class?
                        if (typeof _jquery2.default !== "undefined" && _jquery2.default !== null) {
                            (0, _jquery2.default)("main.mylife-content").scrollTop(0);
                        }
                    }
                }, 0);
            }
        }
    }, {
        key: 'goBack',
        value: function goBack(alternativeRoute) {
            this.go(-1, alternativeRoute);
        }
    }, {
        key: 'go',
        value: function go(number, alternativeRoute) {
            var location = this.props.location ? this.props.location : this.context.location;
            if (location.state && location.state.inAppNav) {
                this.context.history.go(number);
            } else {
                this.transitionTo(alternativeRoute);
            }
        }
    }]);

    return Component;
}(_mlComponent.ComponentBase);

exports.default = Component;

Component.contextTypes = _extends({}, _mlComponent.ComponentBase.contextTypes, {
    location: _react2.default.PropTypes.object,
    history: _react2.default.PropTypes.object
});
Component.childContextTypes = _extends({}, _mlComponent.ComponentBase.childContextTypes, {
    location: _react2.default.PropTypes.object
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-component-web/dist/Component.js
 ** module id = 253
 ** module chunks = 0
 **/